import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_EMPLOYEE_FAILURE,
  CREATE_EMPLOYEE_REQUEST,
  GET_ALL_EMPLOYEE_SUCCESS,
  GET_ALL_EMPLOYEE_REQUEST,
  GET_ALL_EMPLOYEE_FAILURE,
  GET_ALL_EMPLOYEE_PERFORMANCE_SUCCESS,
  GET_ALL_EMPLOYEE_PERFORMANCE_REQUEST,
  GET_ALL_EMPLOYEE_PERFORMANCE_FAILURE,
  DELETE_EMPLOYEE_REQUEST,
  DELETE_EMPLOYEE_FAILURE,
  UPDATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_FAILURE,
  UPDATE_EMPLOYEE_STATUS_REQUEST,
  UPDATE_EMPLOYEE_STATUS_FAILURE,
  DELETE_EMPLOYEE_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllEmployee = () => async (dispatch) => {
  dispatch({ type: GET_ALL_EMPLOYEE_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/employees`);
    dispatch({ type: GET_ALL_EMPLOYEE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_EMPLOYEE_FAILURE, payload: error.message });
  }
};

export const createEmployee = (masterPinCodeId, employeeData, formData, handleCloseModal, handleCancle) => async (dispatch) => {
  dispatch({ type: CREATE_EMPLOYEE_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/employee/masterPinCode/${masterPinCodeId}`, employeeData);
    if (data) {
      await privateAxios.put(
        `admin/employee/${data?.id}/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      dispatch(getAllEmployee());
      toast.success("Employee Register Successfully !!");
      handleCloseModal();
      handleCancle();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_EMPLOYEE_FAILURE, payload: error.message });
  }
};

export const updateEmployee = (employeeId, masterPinCodeId, employeeData, formData, handleCloseModal, handleCancle) => async (dispatch) => {
  dispatch({ type: UPDATE_EMPLOYEE_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/employee/${employeeId}/masterPinCode/${masterPinCodeId}`,
      employeeData
    );
    if (data.status === "SUCCESS") {
      if (formData && formData.get("frontImage") && formData.get("frontImage").name && formData.get("backImage") && formData.get("backImage").name) {
        await privateAxios.put(
          `admin/employee/${employeeId}/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
      }
      dispatch(getAllEmployee());
      toast.success("Employee Updated Successfully");
      handleCloseModal();
      handleCancle();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_EMPLOYEE_FAILURE, payload: error.message });
  }
};
export const toggleEmployeeStatus = (employeeId, isEnabled) => async (dispatch) => {
  dispatch({ type: UPDATE_EMPLOYEE_STATUS_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/employee/${employeeId}/${!isEnabled}`
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllEmployee());
      toast.success(`Employee ${!isEnabled ? "Enabled" : "Disabled"} Successfully`);
    } else {
      toast.error(data.response || "Something went wrong.");
      dispatch({ type: UPDATE_EMPLOYEE_STATUS_FAILURE, payload: data.response });
    }

  } catch (error) {
    console.error("error:", error);

    const message =
      error?.response?.data?.response ||
      error?.message ||
      "Failed to update employee status.";

    toast.error(message);

    dispatch({ type: UPDATE_EMPLOYEE_STATUS_FAILURE, payload: message });
  }
};


export const deleteEmployee = (employeeId) => async (dispatch) => {
  dispatch({ type: DELETE_EMPLOYEE_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/employee/${employeeId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllEmployee());
      dispatch({ type: DELETE_EMPLOYEE_SUCCESS, payload: employeeId });
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_EMPLOYEE_FAILURE, payload: error.message });
  }
};

export const getAllEmployeePerformance = () => async (dispatch) => {
  dispatch({ type: GET_ALL_EMPLOYEE_PERFORMANCE_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/employees/performance`);
    dispatch({ type: GET_ALL_EMPLOYEE_PERFORMANCE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_EMPLOYEE_PERFORMANCE_FAILURE, payload: error.message });
  }
};
